export const isMac =
  typeof navigator !== "undefined" &&
  /Mac|iPhone|iPad|iPod/.test(navigator.userAgent);

export const getModifierKey = () => {
  return {
    alt: isMac ? "⌥" : "ALT",
    altLabel: isMac ? "Option" : "Alt",
    ctrl: isMac ? "⌘" : "Ctrl",
    ctrlLabel: isMac ? "Command" : "Ctrl",
    shift: "⇧",
    shiftLabel: "Shift",
  };
};
